import React, { useEffect, useState } from 'react';
import { FaClock } from 'react-icons/fa';
import useApiCallHooks from '../../../hooks/useApiCallHooks';
import { Link } from 'react-router-dom';
import OverlayLoader from '../../../components/Common/OverlayLoader';

const TrainingRoadmaps = ({ onStartClick }) => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    callAPI('get', 'student-programs');
  }, []);

  useEffect(() => {
    if (responce?.success && Array.isArray(responce.data)) {
      setPrograms(responce.data);
    }
  }, [responce]);

  // Debug Logs
  console.log('API Debug Logs:');
  console.log('Response:', responce);
  console.log('Loading:', loading);
  console.log('Error:', error);
  console.log('Status Code:', statusCode);

  return (
    <div className="j-training-roadmaps">
      <OverlayLoader show={loading} />

      <div className="container py-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Choose Your Training Roadmap</h2>
          <p className="text-muted">
            Multiple specializations available with flexible entry points. Start your journey
            regardless of your current academic year.
          </p>
        </div>

        <section className="all-courses-area py-4">
            <div className="container">
              <div className="row">
                {responce?.data?.map((course) => (
                  <div
                    className="col-12 col-md-6 col-lg-4 mb-4"
                    key={course.id}
                  >
                    <div className="courses__item shine__animate-item me-1">
                      <div className="courses__item-thumb">
                       <Link to={`/program/details/${course.slug}`}>
                          <img
                            src={course.image}
                            alt="course"
                            className="img-fluid"
                          />
                        </Link>
                      </div>
                      <div className="courses__item-content">
                        <ul className="courses__item-meta list-wrap">
                          <li className="courses__item-tag">
                            <Link to={`/program/details/${course.slug}`}>{course.tag}</Link>
                          </li>
                          <li className="avg-rating">
                            <i className="fas fa-star"></i> ({course.rating}{" "}
                            Reviews)
                          </li>
                        </ul>
                        <h5 className="title m-0">
                           <Link to={`/program/details/${course.slug}`}>{course.name}</Link>
                        </h5>
                        <p className="courses_mini_titile my-2">
                                                   {course.description}
                        </p>
                        <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                          <div className="courses__item_point">
                            <i className="fas fa-book px-2"></i>
                            {course.duration}
                          </div>
                          <div className="courses__item_point">
                            <i className="fas fa-tasks px-2"></i>
                            {course.activities}
                          </div>
                        </div>
                        <ul className="list-unstyled d-flex flex-column gap-1 py-2">
                          {course.learning_points.map((learning_points, index) => (
                            <li
                              key={index}
                              className="d-flex align-items-center"
                            >
                              <i className="fas fa-check-circle text-success me-2"></i>
                              <span>{learning_points}</span>
                            </li>
                          ))}
                        </ul>
                        <div className="courses__item-bottom">
                      <Link to={`/program/details/${course.slug}`}>
  <button className="btn w-100 text-white rounded">
    Enroll Now
  </button>
</Link>
                        
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
      </div>
    </div>
  );
};

export default TrainingRoadmaps;
